import util from '../util'

let controller = 'OperadorFrontEndCategoriaNotificacao'
export default Object.assign({}, util.GetCrud(controller, null))